import $ from 'jquery';

// Extracts a model errors dictionary from common server payload shapes.
function getModelErrorBag(payload) {
  if (!payload) return null;

  // ASP.NET Core problem details / ModelState "errors" bag
  if (payload.errors && typeof payload.errors === 'object') {
    return payload.errors;
  }

  // Some APIs return ModelState directly or as "modelState"
  if (payload.ModelState && typeof payload.ModelState === 'object') {
    return payload.ModelState;
  }
  if (payload.modelState && typeof payload.modelState === 'object') {
    return payload.modelState;
  }

  // Fallback: if the payload itself is a bag
  if (typeof payload === 'object' && !Array.isArray(payload)) {
    // Detect if values look like array-of-messages
    const keys = Object.keys(payload);
    if (keys.length && Array.isArray(payload[keys[0]])) {
      return payload;
    }
  }

  return null;
}

// Normalizes a field name as used in your inputs.
// Adjust here if server keys differ (e.g., 'Username' vs 'username').
function normalizeFieldName(key) {
  if (!key) return key;
  // Treat '.' or empty as summary/form-level error
  if (key === '.' || key === '') return '';
  return key;
}

// Applies the bag to vee-validate form context
function applyModelErrorsToForm(bag, formCtx) {
  if (!bag || !formCtx) return { summary: [] };

  const { setErrors, setFieldError } = formCtx;

  const fieldErrors = {};
  const summary = [];

  Object.keys(bag).forEach((rawKey) => {
    const key = normalizeFieldName(rawKey);
    const messages = Array.isArray(bag[rawKey]) ? bag[rawKey] : [String(bag[rawKey] ?? '')];

    if (key === '' || key === '_summary') {
      // Summary / non-field errors
      summary.push(...messages.filter(Boolean));
      return;
    }

    const message = messages.find(Boolean) || '';
    if (message) {
      // Prefer field-level API when available to not overwrite others
      if (typeof setFieldError === 'function') {
        setFieldError(key, message);
      } else {
        fieldErrors[key] = message;
      }
    }
  });

  if (Object.keys(fieldErrors).length && typeof setErrors === 'function') {
    setErrors(fieldErrors);
  }

  return { summary };
}

// Public: call in a catch(error) block for Axios requests.
// Returns true if error was a 400 with model errors and has been consumed.
export function applyServerErrorsFromAxios(error, formCtx) {
  const response = error?.response;
  if (!response || response.status !== 400) {
    return false;
  }

  const bag = getModelErrorBag(response.data);
  if (!bag) {
    return false;
  }

  applyModelErrorsToForm(bag, formCtx);
  return true;
}

// Public: focus the first invalid field after setting errors (a11y-friendly).
export function focusFirstInvalid(formEl) {
  if (!formEl || typeof formEl.querySelector !== 'function') {
    return;
  }
  // Common invalid selectors: aria-invalid or error CSS class
  const first =
    formEl.querySelector('[aria-invalid="true"]') ||
    formEl.querySelector('.input-validation-error') ||
    formEl.querySelector('input[aria-invalid="true"], select[aria-invalid="true"], textarea[aria-invalid="true"]');

  if (first && typeof first.focus === 'function') {
    first.focus();
  }
}

// Public: convenience to clear form errors before a new submit
export function clearFormErrors(formCtx) {
  if (formCtx?.setErrors) {
    formCtx.setErrors({});
  }
}

function showErrors(component, form, modelErrors) {
  const vvErrors = component.errors;

  const summaryErrors = [];
  for (let key in modelErrors) {
    if (modelErrors.hasOwnProperty(key)) {
      var name = key.replace(/([\\!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g, '\\$1');
      if ($(form).find("[name='" + name + "']").length === 0) {
        summaryErrors.push(modelErrors[key]);
        delete modelErrors[key];
      }
    }
  }

  summaryErrors.forEach(e => [].concat(...e).forEach(m => vvErrors.add('.', m)));
  for (let key in modelErrors) {
    [].concat(...modelErrors[key]).forEach(m => vvErrors.add(key, m));
  }
}

export default {
  methods: {
    hasErrorOn: function (name) {
      return this.errors.has(name) && this.fields[name].pristine;
    },

    validateResponse: function (form, response) {
      if (response && response.status === 400) {
        showErrors(this, form, response.data);
        return true;
      }
      return false;
    },

    hasAntiforgeryToken: function () {
      let match = document.cookie.match(new RegExp('XSRF-TOKEN' + '=([^;]+)'));
      return match;
    },

    showErrorSummary: function (form, data) {
      showErrors(this, form, data);
    }
  },
};
